// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"76":"df70bae9","213":"d2bbae6e"}[chunkId] + ".chunk.js";
};